export enum SigningStatus {
    Checking = "Checking",
    Ready = "Ready",
    NotConfigured = "NotConfigured",
    NoCertificate = "NoCertificate",
    TokenNotConnected = "TokenNotConnected"
}

export const SigningStatusUtil = {
    getStringValue: (status: SigningStatus | null | undefined): string => {
        switch (status) {
            case SigningStatus.Checking:
                return "Проверка";
            case SigningStatus.Ready:
                return "Готово";
            case SigningStatus.NotConfigured:
                return "Не настроено";
            case SigningStatus.NoCertificate:
                return "Сертификат не выбран";
            case SigningStatus.TokenNotConnected:
                return "USB-ключ не подключён";
            default:
                return "";
        }
    }
};

